import { render, staticRenderFns } from "./TableMotionAlarm.vue?vue&type=template&id=985e23bc"
import script from "./TableMotionAlarm.vue?vue&type=script&lang=js"
export * from "./TableMotionAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports